"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// TODO(2fd): check for a better options, may cause a lot of unnecessary re renders
const react_1 = require("react");
const framer_motion_1 = require("framer-motion");
const SingletonListener_1 = __importDefault(require("../utils/dom/SingletonListener"));
function useWindowScroll() {
    const scrollX = (0, framer_motion_1.useMotionValue)(0);
    const scrollY = (0, framer_motion_1.useMotionValue)(0);
    const height = (0, framer_motion_1.useMotionValue)(1);
    const width = (0, framer_motion_1.useMotionValue)(1);
    const [state, setState] = (0, react_1.useState)({
        scrollX,
        scrollY,
        height,
        width,
    });
    (0, react_1.useEffect)(() => {
        const updateScrollValues = () => {
            scrollX.set(window.scrollX);
            scrollY.set(window.scrollY);
            height.set(window.innerHeight);
            width.set(window.innerWidth);
            setState((current) => (Object.assign(Object.assign({}, current), { scrollX,
                scrollY,
                height,
                width })));
        };
        const listener = SingletonListener_1.default.from(window);
        listener.addEventListener('resize', updateScrollValues);
        listener.addEventListener('scroll', updateScrollValues);
        return () => {
            listener.removeEventListener('resize', updateScrollValues);
            listener.removeEventListener('scroll', updateScrollValues);
        };
    });
    return state;
}
exports.default = useWindowScroll;
